__webpack_require__.p = "/wic-tasks-2024/";